import { Component } from 'react';

/**
 * Catches any uncaught React render error so the app does not present a
 * completely blank white screen. Shows a minimal recovery UI with a Reload
 * button and copies the error details to the clipboard on demand — handy for
 * admins reporting issues from production.
 */
export default class ErrorBoundary extends Component {
  state = { error: null, info: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary] React crash:', error, info);
    this.setState({ info });
  }

  copyDetails = () => {
    const details = `${this.state.error?.toString() || ''}\n\n${this.state.info?.componentStack || ''}`;
    try {
      navigator.clipboard.writeText(details);
    } catch (_) { /* ignore */ }
  };

  render() {
    if (this.state.error) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#0b0b0d',
          color: '#fafafa',
          fontFamily: 'system-ui, sans-serif',
          padding: 24,
        }}>
          <div style={{ maxWidth: 540, textAlign: 'center' }}>
            <h1 style={{ fontSize: 22, color: '#facc15', letterSpacing: 2, marginBottom: 12 }}>
              SAN SECURITY
            </h1>
            <h2 style={{ fontSize: 18, marginBottom: 8 }}>Something went wrong</h2>
            <p style={{ color: '#a1a1aa', fontSize: 14, marginBottom: 20 }}>
              The page hit an unexpected error and stopped rendering. Try reloading.
              If it keeps happening, copy the details and send them to support.
            </p>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
              <button
                onClick={() => window.location.reload()}
                style={{
                  background: '#facc15', color: '#000', border: 'none',
                  padding: '10px 18px', fontWeight: 600, cursor: 'pointer',
                  borderRadius: 4, textTransform: 'uppercase', letterSpacing: 1,
                }}
              >
                Reload
              </button>
              <button
                onClick={this.copyDetails}
                style={{
                  background: 'transparent', color: '#fafafa',
                  border: '1px solid #3f3f46', padding: '10px 18px',
                  cursor: 'pointer', borderRadius: 4,
                }}
              >
                Copy error details
              </button>
            </div>
            {this.state.error && (
              <pre style={{
                marginTop: 24, textAlign: 'left', background: '#18181b',
                padding: 12, fontSize: 11, color: '#fca5a5',
                whiteSpace: 'pre-wrap', wordBreak: 'break-word',
                borderRadius: 4, maxHeight: 200, overflow: 'auto',
              }}>
                {this.state.error.toString()}
              </pre>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
